'use client';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export const Loading = (): React.JSX.Element => {
  return (
    <Box component="main" sx={{ p: 4 }}>
      <Grid container direction="column" alignItems="center" justifyContent="center" spacing={4}>
        <Typography variant="h3" component="h3">
          Now Loading...
        </Typography>
        <CircularProgress enableTrackSlot color="inherit" size={60} />
      </Grid>
    </Box>
  );
};
